import {
  AnnsModal,
  Col,
  FormInput,
  FormInputType,
  Icon,
  RadioButtonOptions,
} from "../../../../components/Component";
import { Form, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useEffect } from "react";
import { addLocationAPI } from "./LocationTableData";
import {
  AppText,
  RadioOptionTypes,
  showErrorToast,
  showSuccessToast,
} from "../../../../utils";
import { fileUploadApi } from "../../Transaction/TransactionData";
import { openLinkInNewTab } from "../../../../utils/Functions";
import { iconsType } from "../../../../utils/Utils";

const AddLocation = ({ visible, item, onSaved, onClosed }) => {
  const [locationData, setLocationData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [selectedFile, setSelectedFile] = useState([]);
  const [removeFileIds, setRemoveFileIds] = useState([]);

  useEffect(() => {
    if (
      (locationData?.name?.length ?? 0) === 0 ||
      (locationData?.totalBeds?.length ?? 0) === 0
    ) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [locationData]);

  useEffect(() => {
    if (visible) {
      if (item) {
        setLocationData({
          ...locationData,
          id: item?.id,
          name: item?.name,
          totalBeds: "" + item?.totalBeds,
          isActive: item?.isActive || false,
        });
      } else {
        setLocationData({ ...locationData, name: "", isActive: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, item]);

  const close = () => {
    onClosed();
    setLoading(false);
    setLocationData({});
  };

  const onFormSubmit = () => {
    if (isDisable) return;
    setLoading(true);
    const importFileId = selectedFile.length > 0 && selectedFile[0]?.id;
    const params = {
      ...locationData,
      importFileId: importFileId,
    };

    addLocationAPI(params, (_, error) => {
      if (error === null) {
        let text =
          "Location" +
          (item ? AppText.EditedSuccessfully : AppText.AddedSuccessfully);
        showSuccessToast(text);
        onSaved();
        close();
      } else {
        showErrorToast(error.message);
      }
      setLoading(false);
    });
  };

  const {  handleSubmit } = useForm();

  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "https://api.saundersreco.co.uk/import-template/resident.xls";
    link.download = "resident.xls";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileSelect = (file) => {
    if (selectedFile.length > 0) {
      showErrorToast("Only one file can be attached at a time.");
      return;
    }
    const fileDetails = file;
    fileDetails.isLoading = true;
    fileDetails.isError = false;
    fileDetails.id = null;

    const updatedfiles = [...selectedFile];
    updatedfiles.push(fileDetails);
    setSelectedFile(updatedfiles);

    uploadFile(fileDetails, updatedfiles.length - 1);
  };

  const uploadFile = (file, index) => {
    fileUploadApi(file, "RESIDENT_IMPORT", (data, error) => {
      const updatedfiles = [...selectedFile];

      if (error === null) {
        file.id = data.id;
        file.fileUrl = URL.createObjectURL(file);
        file.isLoading = false;
        updatedfiles[index] = file;
        setSelectedFile(updatedfiles);
      } else {
        updatedfiles.splice(index, 1);
        setSelectedFile(updatedfiles);
        showErrorToast(
          error.message.length > 0 ? error.message : AppText.connectError
        );
      }
    });
  };

  const handleFileRemove = (index) => {
    const updatedfiles = [...selectedFile];
    const removeFile = updatedfiles[index];
    updatedfiles.splice(index, 1);
    setSelectedFile(updatedfiles);

    if (removeFile?.isOldFile === true) {
      setRemoveFileIds([...removeFileIds, removeFile.id]);
    }
  };

  return (
    <>
      <AnnsModal
        size={"sm"}
        isOpen={visible}
        toggle={() => onClosed()}
        title={item ? "Edit Location" : "Add Location"}
        onClick={() => onFormSubmit()}
        disabled={isDisable}
        loading={loading}
      >
        <Form
          className="row gy-4 form-validation"
          onSubmit={handleSubmit(onFormSubmit)}
        >
          <Col md="12">
            <div className="form-group">
              <div className="form-control-wrap">
                <FormInput
                  label={"Location"}
                  type={FormInputType.default}
                  value={locationData?.name}
                  onTextChange={(text) => {
                    setLocationData((prev) => ({
                      ...prev,
                      name: text,
                    }));
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md="12">
            <div className="form-group">
              <div className="form-control-wrap">
                <FormInput
                  label={"Bed"}
                  type={FormInputType.number}
                  value={locationData?.totalBeds}
                  onTextChange={(text) => {
                    setLocationData((prev) => ({
                      ...prev,
                      totalBeds: text,
                    }));
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md="12">
            <div className="form-group">
              <div className="form-control-wrap">
                <RadioButtonOptions
                  name="status"
                  optionType={RadioOptionTypes.status}
                  onChange={(index) => {
                    setLocationData((prev) => ({
                      ...prev,
                      isActive: index === 0,
                    }));
                  }}
                  activeIndex={locationData.isActive ? 0 : 1}
                />
              </div>
            </div>
          </Col>
          {!item && (
            <>
              <Col md="12">
                <div className="d-flex justify-content-between align-center">
                  <span className="fs-6 fw-bold">Download Template</span>
                  <span
                    onClick={() => handleDownloadTemplate()}
                    className="cursor-pointer text-primary"
                  >
                    Download
                  </span>
                </div>
              </Col>
              <Col md="12">
                <div className="d-flex justify-content-between align-center">
                  <span className="fs-6 fw-bold">Select File</span>
                  <div>
                    <div className="form-group mb-0 ms-3">
                      <label htmlFor="files">
                        <Icon name="clip" className="mb-1 text-primary" />
                        <span className="text-primary"> Attach file</span>
                      </label>
                      <div className="text-end">
                        <input
                          id={"files"}
                          type="file"
                          accept=".xlsx,.xls"
                          className="form-control"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            let file = e.target.files;
                            if (file.length > 0) {
                              handleFileSelect(file[0]);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </>
          )}
          {selectedFile && selectedFile.length > 0 ? (
            <div className="selected-file-container">
              {selectedFile.map((file, index) => (
                <div className="nk-upload-item" key={`file-${index}`}>
                  <div
                    className="nk-upload-icon cursor-pointer"
                    onClick={() => {
                      openLinkInNewTab(file?.fileUrl);
                    }}
                  >
                    {file?.isOldFile ? (
                      <>
                        {iconsType[file?.mimeType]
                          ? iconsType[file?.mimeType]
                          : iconsType["others"]}
                      </>
                    ) : (
                      <>
                        {iconsType[file?.type]
                          ? iconsType[file?.type]
                          : iconsType["others"]}
                      </>
                    )}
                  </div>
                  <div
                    className="nk-upload-info cursor-pointer d-flex justify-content-between align-items-center"
                    onClick={() => openLinkInNewTab(file?.fileUrl)}
                  >
                    <div className="nk-upload-title">
                      <span className="title">{file?.name}</span>
                    </div>
                  </div>
                  <div className="nk-upload-action">
                    <button
                      onClick={(ev) => {
                        ev.preventDefault();
                      }}
                      className="btn btn-icon btn-trigger round-40  d-flex justify-content-center align-items-center"
                    >
                      {file?.isLoading ? (
                        <Spinner size="sm" color="dark" />
                      ) : (
                        <>
                          <span onClick={() => handleFileRemove(index)}>
                            <Icon name="trash"></Icon>
                          </span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </Form>
      </AnnsModal>
    </>
  );
};

export default AddLocation;
